"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var mapViewportSizeToPx = function (size) {
    switch (size) {
        case "xs":
            return 0;
        case "sm":
            return 576;
        case "md":
            return 768;
        case "lg":
            return 992;
        case "xl":
            return 1200;
        default:
            return null;
    }
};
exports.default = mapViewportSizeToPx;
//# sourceMappingURL=index.js.map